
import React from 'react';
import { Link } from 'react-router-dom';
import MesHero from '../../../../../Assets/Mes/1.png'

const MesHeroSection = () => {
  return (
    <div className="w-full relative overflow-hidden h-screen max-h-[600px]">
      {/* Desktop background shapes */}
      <div 
        style={{ 
          position: 'absolute',
          top: 0,
          left: 0,
          width: '60%',
          height: '100%',
          backgroundColor: '#0089D0', // Primary blue
          clipPath: 'polygon(0 0, 100% 0, 85% 100%, 0 100%)',
          zIndex: 0
        }} 
        className="hidden md:block"
      />
      
      {/* Secondary background accent */}
      <div 
        style={{ 
          position: 'absolute',
          top: '15%',
          left: '-5%',
          width: '35%',
          height: '70%',
          backgroundColor: '#006EAC', // Darker blue accent
          clipPath: 'polygon(0 15%, 100% 0, 90% 100%, 10% 85%)',
          opacity: 0.4,
          zIndex: 0
        }} 
        className="hidden md:block"
      />
      
      {/* Lighter blue accent */}
      <div 
        style={{ 
          position: 'absolute',
          top: '5%',
          left: '40%',
          width: '25%',
          height: '60%',
          backgroundColor: '#39A9DB', // Lighter blue accent
          clipPath: 'polygon(0 0, 100% 20%, 80% 100%, 20% 80%)',
          opacity: 0.3,
          zIndex: 0
        }} 
        className="hidden md:block"
      />
      
      {/* Mobile background shapes */}
      <div 
        style={{ 
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '50%',
          backgroundColor: '#0089D0', // Primary blue
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 70%)',
          zIndex: 0
        }} 
        className="block md:hidden"
      />
      
      {/* Mobile secondary blue accent */}
      <div 
        style={{ 
          position: 'absolute',
          top: '5%',
          left: '-10%',
          width: '60%',
          height: '40%',
          backgroundColor: '#006EAC', // Darker blue accent
          clipPath: 'polygon(0 15%, 100% 0, 90% 100%, 10% 85%)',
          opacity: 0.4,
          zIndex: 0
        }} 
        className="block md:hidden"
      />
      
      {/* Mobile lighter blue accent */}
      <div 
        style={{ 
          position: 'absolute',
          top: '10%',
          right: '-10%',
          width: '60%',
          height: '30%',
          backgroundColor: '#39A9DB', // Lighter blue accent
          clipPath: 'polygon(10% 0, 100% 20%, 90% 100%, 0% 80%)',
          opacity: 0.3,
          zIndex: 0
        }} 
        className="block md:hidden"
      />
      
      {/* Mobile image */}
      <div className="md:hidden absolute bottom-0 left-0 w-full h-1/2 z-0">
        <img 
          src={MesHero}
          alt="KCS Tech's Infor MES" 
          className="w-full h-full object-cover"
        />
        {/* Subtle gradient overlay - made much lighter to show image */}
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(to bottom, rgba(0, 137, 208, 0.6) 0%, rgba(0, 137, 208, 0) 40%)',
          }}
        />
      </div>
      
      {/* Content container */}
      <div className="container mx-auto px-4 md:px-8 py-8 md:py-24 relative z-10 h-full flex flex-col md:flex-row items-center">
        {/* Content section */}
        <div className="md:w-1/2 w-full mb-auto mt-8 md:mt-0 md:mb-0">
          <h1 className="text-white text-3xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 drop-shadow-md">
            Manufacturing<br />
            Execution Systems<br />
            <span style={{ color: '#F8F9FA' }}>(MES)</span>
          </h1>
          <p className="sm:text-[#1d3658] md:text-[#ffff] lg:text-[#ffff] text-lg md:text-2xl mb-6 md:mb-8 drop-shadow">
            Crafting the Future of Manufacturing, One Process at a Time
          </p>
          <button 
            style={{ 
              backgroundColor: '#FFFFFF',
              color: '#0071BC',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}
            className="px-5 py-2 md:px-6 md:py-3 rounded font-medium hover:opacity-90 transition-opacity duration-300"
          >
            <Link to="/contact">REQUEST IN-DEPTH DEMO</Link>
          </button>
        </div>
      </div>
      
      {/* Desktop image section with masked overlay */}
      <div 
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '50%',
          height: '100%',
          clipPath: 'polygon(15% 0, 100% 0, 100% 100%, 0% 100%)',
          zIndex: 5
        }}
        className="hidden md:block"
      >
        {/* Image */}
        <img 
          src={MesHero} 
          alt="Factory workers with tablet" 
          className="w-full h-full object-cover"
        />
        
        {/* Gradient overlay on image */}
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(to right, rgba(0, 137, 208, 0.7) 0%, rgba(0, 137, 208, 0) 50%)',
            zIndex: 6
          }}
        />
      </div>
    </div>
  );
}

export default MesHeroSection;